// CartContext.jsx
// import React, { createContext, useContext, useState } from 'react';
import React, { createContext, useContext, useState, useCallback } from 'react';
import axios from 'axios';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);
export const useCartDrawer = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [cartData, setCartData] = useState([]);
    const [subtotal, setSubtotal] = useState(0);

    const openCart = () => setIsCartOpen(true);
    const closeCart = () => setIsCartOpen(false);


    // add
    // const fetchCartData = useCallback(async () => {
    //     const user = JSON.parse(localStorage.getItem('user'));
    //     if (!user?.UserID) return;
    //     try {
    //         const res = await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/getcartdetails`, {
    //             Customer_ID: user.UserID
    //         });

    //         setCartData(res.data);

    //     } catch (error) {
    //         // console.error('Error fetching cart data:', error);
    //     }
    // }, []);
    const fetchCartData = useCallback(async () => {
        const user = JSON.parse(localStorage.getItem('user'));

        if (!user?.UserID) {
            // ✅ Guest 
            const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
            setCartData({ AddToCartDetails: [guestCart, [{ FinalAmount: 0 }]] });
            return;
        }

        try {
            const res = await axios.post(
                `${process.env.REACT_APP_SECRET_KEY}/api/getcartdetails`,
                { Customer_ID: user.UserID }
            );
            setCartData(res.data);
        } catch (error) { }
    }, []);
    return (
        // <CartContext.Provider value={{ isCartOpen, openCart, closeCart }}>
        <CartContext.Provider value={{
            isCartOpen,
            openCart,
            closeCart,
            cartData,
            setCartData,
            fetchCartData,
            subtotal,
            setSubtotal
        }}>
            {children}
        </CartContext.Provider>
    );
};
